import createAPI from '../axios'

// 教学场地管理相关API
const teachingSiteManage = {
	teachingSiteInfo: {
	    list: config => createAPI('/teachingSiteInfo/list', 'post', config),
        initOption: config => createAPI('/teachingSiteInfo/initOption', 'post', config),
        timeslotOption: config => createAPI('/teachingSiteInfo/timeslotOption', 'post', config),
        querySiteTree: config => createAPI('/teachingSiteInfo/querySiteTree', 'post', config),
		updateSite: config => createAPI('/teachingSiteInfo/updateSite', 'post', config),
        checkTerm: config => createAPI('/teachingSiteInfo/checkTerm', 'post', config),
        saveWeekTimeslot: config => createAPI('/teachingSiteInfo/saveWeekTimeslot', 'post', config),
        copyTerm: config => createAPI('/teachingSiteInfo/copyTerm', 'post', config),
	},
    teachingSiteApply: {
        list: config => createAPI('/teachingSiteApply/list', 'post', config),
        initOption: config => createAPI('/teachingSiteApply/initOption', 'post', config),
        siteOption: config => createAPI('/teachingSiteApply/siteOption', 'post', config),
    	checkDate: config => createAPI('/teachingSiteApply/checkDate', 'post', config),
        saveApply: config => createAPI('/teachingSiteApply/saveApply', 'post', config),
        delApply: config => createAPI('/teachingSiteApply/delApply', 'post', config),
        updateAuditState: config => createAPI('/teachingSiteApply/updateAuditState', 'post', config),
    },
    teachingSiteStatistics: {
        list: config => createAPI('/teachingSiteStatistics/list', 'post', config),
        initOption: config => createAPI('/teachingSiteStatistics/initOption', 'post', config),
        weekOption: config => createAPI('/teachingSiteStatistics/weekOption', 'post', config),
        queryApplyWeek: config => createAPI('/teachingSiteStatistics/queryApplyWeek', 'post', config),
        roomUsageExport: config => createAPI('/teachingSiteStatistics/roomUsageExport', 'post', config),
    },
    teachingSiteFreetime: {
        list: config => createAPI('/teachingSiteFreetime/list', 'post', config),
        initOption: config => createAPI('/teachingSiteFreetime/initOption', 'post', config),
        weekOption: config => createAPI('/teachingSiteFreetime/weekOption', 'post', config),
        queryApplyWeek: config => createAPI('/teachingSiteFreetime/queryApplyWeek', 'post', config),
    }
};

export default teachingSiteManage;



// WEBPACK FOOTER //
// ./src/api/modules/teachingSiteManage.js